import { useState } from 'react';
import Cookies from 'universal-cookie';

const COOKIE_NAME = 'ac_uhq_token';

export default function useToken() {
    const cookies = new Cookies();

    const getToken = () => {
        // const tokenString = sessionStorage.getItem('token');
        const tokenString = cookies.get(COOKIE_NAME)
        return tokenString;
    };

    const [token, setToken] = useState(getToken());

    const saveToken = userToken => {
        // sessionStorage.setItem('token', JSON.stringify(userToken));
        cookies.set(COOKIE_NAME, userToken, { path: '/' });
        setToken(userToken);
    };

    const clearToken = () => {
        //        sessionStorage.removeItem('token');
        cookies.remove(COOKIE_NAME, { path: '/' });
        setToken(undefined);
    }

    return {
        setToken: saveToken,
        clearToken: clearToken,
        token
    }
}